import { useState, useContext, useEffect } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { confirmDialog } from "primereact/confirmdialog";
import { Button, Calendar, InputText, InputTextarea } from "primereact";
import { SplitButton } from "primereact/splitbutton";

// ------------------ COMPONENTES DE BASE--------------------------
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import Card from "../../../../Base/Components/Card/Card";
import Loader from "../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { ReusableDialog } from '../../../../Base/Components/Dialog/ReusableDialog'

// ------------------ CONSULTAS A LA API--------------------------
import { getBuyers } from "../../../../API/Clientes/ClientesRequests";
import { EliminarDetalles, getNewLink } from "../../../../API/Ventas/Cotizaciones/CotizacionesRequest";

import ModalAgregarDet from './ModalAgregarDet'
import ReporteCotizacion from '../ReporteCotizacion'
import { sendEmail } from "../../../../Base/Services/Email/EmailRequest";


const EncabezadoCotizacion = ({
  values,
  setValues,
  handleInputChange,
  toast,
  habilitar,
  setHabilitar,
  clientes,
  buyers,
  setBuyers,
  agentes,
  paymentTerm,
  shipmentTerm,
  costosAdicionales,
  setCostosAdicionales,
  costosOtros,
  setCostosOtros,
  totalAdicional,
  setTotalAdicional,
  totalOtros,
  setTotalOtros,
  agregarNuevaFila,
  guardarCotizacion,
  dialogDetails,
  setDialogDetails,
  selected,
  setSelected,
  getInfo,
  detalles,
  setDetalles,
  selectedEnc,
  setTotal,
  total,
  obtener,
  duplicarCotizacion,
  guardarCotizacion1 = () => {},
  origen
}) => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [selectedR, setSelectedR] = useState([]);
  const [lenguaje, setLenguaje] = useState('es');
  const [showReporte, setShowReporte]= useState(false);
  const [showDialog, setShowDialog]= useState(false);
  const [idQuotation, setIdQuotation]= useState(null);
  const [enlace, setEnlace]= useState(null);
  const [correoAEnviar, setCorreoAEnviar] = useState([]);
  const [idioma, setIdioma] = useState('es')
  

  const verificarCampos = () => {
    let err = false;

    if (!values?.CustomerName && !values?.CustomerName?.IdCustomer) {
      err = true;
      toastShow(toast, "error", "Error", "El cliente es requerido.");
      return;
    }
    if (!values?.CompanyName && !values?.CompanyName?.IdDCustomer) {
      err = true;
      toastShow(toast, "error", "Error", "El buyer es requerido.");
      return;
    }
    if (!values?.UserNameAgent && !values?.UserName?.idUser) {
      err = true;
      toastShow(toast, "error", "Error", "El agente de ventas es requerido.");
      return;
    }
    if (!values?.TermNamePayment && !values?.TermNamePayment?.IdPaymentTerm) {
      err = true;
      toastShow(toast, "error", "Error", "El término de compra es requerido.");
      return;
    }
    if (!values?.TermNameShitment && !values?.TermNameShitment?.IdPaymentTerm) {
      err = true;
      toastShow(toast, "error", "Error", "El término de envío es requerido.");
      return;
    }
    return !err;
  };

  const filtarBuyer = async (IdCustomer) => {
    const buyerT = await getBuyers()
    let filtro = buyerT.filter((i) => i.IdCustomer === IdCustomer);
    if(filtro.length > 0){
      setBuyers(filtro)
    }else{
      toastShow(
        toast,
        "warn",
        "Seleccione otro Cliente",
        "El Cliente seleccionado no cuenta con Buyer Disponibles"
      );
      setBuyers([])
    }

  }

  const ejecutarEliminar = () => {
    const mensaje = selected.length > 1 
      ? `¿Está seguro de eliminar los detalles?`
      : `¿Está seguro de eliminar el detalle?`;
  
    if (selected.length <= 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        `Seleccione al menos un detalle.`
      );
    } else {
      confirmDialog({
        message: mensaje,
        header: "Eliminar Detalle",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          eliminarDet(selected);
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    }
  };

  const eliminarDet = async (Detalles) => {
    Detalles.forEach(async (select) => {
      if (select?.IdQuotationDetail > 0) {
        const respuesta = await EliminarDetalles(select);
      } else {
        let tempo2 = detalles.filter((i) => i.IdQuotationDetail !== select.IdQuotationDetail);
        setDetalles(tempo2);
      }
    });
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      toastShow(
        toast,
        "success",
        "Eliminado",
        Detalles.length > 1 ? "Costos eliminados correctamente" : "Costo eliminado correctamente"
      );
      setSelected([])
      getInfo(selectedEnc); 
    }, 850);
  };
  
  const nuevaCotizacion = () => {
    confirmDialog({
      message: "¿Está seguro que desea crear una nueva cotización?",
      header: "Nueva Cotización",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        getInfo()
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const items = [
    {
      label: "Ingles",
      command: () => {
        setSelectedR([selectedEnc])
        setLenguaje('en')
        setShowReporte(true)
      },
    },
    {
    
      label: "Español",
      command: () => {
        setSelectedR([selectedEnc])
        setLenguaje('es')
        setShowReporte(true)
      },
    },
  ];

  const abrirDialog = async (IdQuotation) => {
    setIdQuotation(IdQuotation)
    setCorreoAEnviar([values?.EmailCustomer])
    obtenerLink(IdQuotation, 'es')
    setTimeout(() => {
      setShowDialog(true)
    }, 500);
  }

  const obtenerLink = async (IdQuotation, languaje) => {
    const resp = await getNewLink(IdQuotation, languaje)
    setEnlace(resp)
  }

  const enviarCorreo = () => {

    confirmDialog({
      message: "Esta seguro que desea enviar el correo",
      header: "Enviar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => enviarCorreoEjecutar(),
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  }

  const enviarCorreoEjecutar = async () => {
    setLoading(true)
    
    const contenidoEs = `<div style="font-size: 14">
        <span>Estimado Cliente: <strong>${values?.CustomerName}</strong> </span><br/><br/>
        <span>Este mensaje se ha generado automáticamente. Por favor no responder.</span>
      </div>`
    
    const contenidoEn = `<div style="font-size: 14">
        <span>Dear Customer: <strong>${values?.CustomerName}</strong> </span><br/><br/>
        <span>This message has been generated automatically. Please do not reply.</span>
      </div>`;

    const objeto = {
      // to: correoAEnviar,
      to: 'lchinchilla@ppf.com.hn',
      cc: '',
      bcc: 'lchinchilla@ppf.com.hn',
      subject: `Subject`,
      texto: idioma === 'es' ? contenidoEs : contenidoEn,
      attachments: null
    }

    const result = await sendEmail(objeto)

    if(result){
      toastShow( toast, "success", "Enviado", "Correo enviado exitosamente.");
      setShowDialog(false)
    }else{
      toastShow(toast, "error", "Error", "Error al enviar correo.");
    }
    setLoading(false)
  }

  return (
    <div>
      <Loader loading={loading} />
      <Card
        contenido={
          <div className="d-flex">
            <div className="col-12">

              {/* --------------------------INPUTS-----------------------  */}
              <div className="d-flex flex-wrap align-items-start gap-1 mt-2">
                {/* No. Cotizacion */}
                <span className="p-inputgroup " style={{ maxWidth: 233 }}>
                  <span className=" field p-float-label">
                    <InputText
                      id="Quotation"
                      name="Quotation"
                      value={values?.Quotation}
                      onChange={handleInputChange}
                      style={{ fontWeight: "bold" }}
                      onKeyDown={(e) =>
                        e.keyCode === 13 ? obtener(values?.Quotation) : null
                      }
                    />
                    <label htmlFor="Quotation">{getLabel(baseLang, "NoCotizacion", config.language)}</label>
                  </span>

                  <Button
                    icon="pi pi-search"
                    type="button"
                    className="p-button-info "
                    onClick={() => obtener(values?.Quotation)}
                    tooltip="Buscar"
                    tooltipOptions={{
                      className: "purple-tooltip",
                      position: "top",
                    }}
                  />
                </span>

                {/* Fecha */}
                <span className="p-float-label">
                  <Calendar
                    id="Date"
                    disabled={!habilitar}
                    name="Date"
                    // handleInputChange={handleInputChange}
                    onChange={(e) => handleInputChange(e, "Date")}
                    value={values?.Date}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                  />
                  <label htmlFor="Date">{getLabel(baseLang, "fecha", config.language)}</label>
                </span>

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values?.CustomerName}
                  items={clientes}
                  field={"CustomerName"}
                  name={"CustomerName"}
                  // handleInputChange={handleInputChange}
                  handleInputChange={(e) => {
                    handleInputChange(e);
                    setValues(prevValues => ({
                      ...prevValues,
                      CompanyName: null
                    }));
                  }}
                  tabIndex={4}
                  label={getLabel(baseLang, "cliente", config.language)}
                />

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values?.CompanyName}
                  items={buyers}
                  field={"CompanyName"}
                  name={"CompanyName"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={getLabel(baseLang, "buyer", config.language)}
                  filterValue={values?.CustomerName}
                  itemsFilter={(e) => {
                    let filtro = buyers.filter((s) => s.IdCustomer === values?.CustomerName?.IdCustomer);
                    let filtro2 = values?.CustomerName?.IdCustomer

                    if(filtro?.length === 0 && filtro2){
                      toastShow(
                        toast,
                        "warn",
                        "Seleccione otro Cliente",
                        "El cliente seleccionado no cuenta con buyer disponibles"
                      );
                    }
                    return filtro
                  }}
                />

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values?.UserName ? values?.UserName : values?.UserNameAgent }
                  items={agentes}
                  field={"UserName"}
                  name={"UserName"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={getLabel(baseLang, "agente", config.language)}
                />

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values?.TermNamePayment}
                  items={paymentTerm}
                  field={"TermNamePayment"}
                  name={"TermNamePayment"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={getLabel(baseLang, "termC", config.language)}
                />

                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values?.TermNameShitment}
                  items={shipmentTerm}
                  field={"TermNameShitment"}
                  name={"TermNameShitment"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={getLabel(baseLang, "termS", config.language)}
                />

                
                <AutoCompleteDropdown
                  enable={habilitar}
                  value={values?.Origin}
                  items={origen}
                  field={"Origin"}
                  name={"Origin"}
                  handleInputChange={handleInputChange}
                  tabIndex={4}
                  label={getLabel(baseLang, "origen", config.language)}
                />

                {/* Comentarios */}
                <span className=" p-float-label d-flex mx-1">
                  <InputTextarea
                    disabled={!habilitar}
                    id="Comment"
                    name="Comment"
                    value={values?.Comment}
                    onChange={handleInputChange}
                    cols={62}
                    style={{
                      width: "100%",
                      maxHeight: "3rem",
                      maxWidth: "72vh",
                      height: "3rem",
                    }}
                  />
                  <label id="label_comentario" htmlFor="Comment">
                    {getLabel(baseLang, "comentario", config.language)}
                  </label>
                </span>
              </div>


              {/* --------------------------BOTONES-----------------------  */}
              <div className="d-flex flex-wrap gap-2 mb-2 mt-4">
                <Button
                  icon="pi pi-plus"
                  disabled={!habilitar}
                  type="button"
                  className="p-button-info encabezado__herramienta-botones"
                  tooltip="Agregar Detalle"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  onClick={(e) => {
                    if (verificarCampos()) {
                      // setDialogDetails(true);
                      agregarNuevaFila()
                    }
                    // setDialogDetails(true);
                    // agregarNuevaFila()
                  }}
                  tabIndex={7}
                />

                <Button
                  icon="pi pi-pencil"
                  type="button"
                  className="p-button-secondary  encabezado__herramienta-botones"
                  onClick={(e) => setHabilitar(true)}
                  tooltip="Editar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />

                <Button
                  icon="pi pi-save"
                  disabled={!habilitar}
                  className="p-button-primary encabezado__herramienta-botones"
                  tooltip="Guardar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  onClick={(e) => {
                    // guardarCotizacion()
                    guardarCotizacion1()
                  }}
                  style={{ marginLeft: 1 }}
                />

                <Button
                  type="button"
                  tooltip="Agregar Costo"
                  disabled={!habilitar}
                  icon="pi pi-times"
                  className="p-button-danger listado__botones"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  onClick={(e) => {
                    ejecutarEliminar();
                  }}
                  tabIndex={7}
                />

                <Button
                  icon="pi pi-book"
                  type="button"
                  disabled={!habilitar}
                  className="p-button-info  encabezado__herramienta-botones"
                  onClick={nuevaCotizacion}
                  tooltip="Nuevo"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />

                <Button
                  icon="pi pi-sync"
                  type="button"
                  disabled={!habilitar}
                  className="p-button-info encabezado__herramienta-botones"
                  onClick={() => getInfo(values)}
                  tooltip="Cargar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />

                <Button
                  icon="pi pi-copy"
                  type="button"
                  disabled={ (values?.IdQuotation <= 0)}
                  onClick={() => duplicarCotizacion(values, detalles)}
                  tooltip="Duplicar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />

                <div className="d-flex flex-row">
                  <SplitButton
                    disabled={ (values?.IdQuotation <= 0)}
                    label=""
                    icon="pi pi-print"
                    onClick={(e) => {
                      setSelectedR([selectedEnc])
                      setLenguaje('es')
                      setShowReporte(true)
                    }}
                    model={items}
                  />
                </div>

                <div className="d-flex flex-row">
                  <Button
                    disabled={ (values?.IdQuotation <= 0)}
                    icon="ri-book-3-line"
                    onClick={(e) => {
                      abrirDialog(selectedEnc?.IdQuotation)
                    }}
                  />
                </div>

              </div>
              
            </div>
          </div>
        }
      />

      {dialogDetails && (
        <ModalAgregarDet
          showDialog={dialogDetails}
          setShowDialog={setDialogDetails}
          costosAdicionales={costosAdicionales}
          setCostosAdicionales={setCostosAdicionales}
          costosOtros={costosOtros}
          setCostosOtros={setCostosOtros}
          totalAdicional={totalAdicional}
          setTotalAdicional={setTotalAdicional}
          totalOtros={totalOtros}
          setTotalOtros={setTotalOtros}
          agregarNuevaFila={agregarNuevaFila}
          selected={selected}
          setSelected={setSelected}
          getInfo={getInfo}
          setTotal={setTotal}
          total={total}
          IdQuotation ={values?.IdQuotation}
        />
      )}


      {showReporte && (
        <ReporteCotizacion
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selected={selectedR}
          setSelected={setSelectedR}
          lenguaje={lenguaje}
        />
      )}


      {showDialog && (
        <ReusableDialog
          visible={showDialog}
          onHide={() => setShowDialog(false)}
          header={"Enviar Correo a " + `${values?.CustomerName}`}
          ejecutar={enviarCorreo}
          obtenerEnlace={obtenerLink}
          Id={idQuotation}
          enlace={enlace}
          correoAEnviar={correoAEnviar}
          setCorreoAEnviar={setCorreoAEnviar}
          idioma={idioma}
          setIdioma={setIdioma}
          setLoading={setLoading}
          loading={loading}
        />
      )}

    </div>
  );
};

export default EncabezadoCotizacion;
